import { render, staticRenderFns } from "./MatriculasAnosIniciaisCard.vue?vue&type=template&id=492c33a6&scoped=true"
import script from "./MatriculasAnosIniciaisCard.vue?vue&type=script&lang=js"
export * from "./MatriculasAnosIniciaisCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasAnosIniciaisCard.vue?vue&type=style&index=0&id=492c33a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492c33a6",
  null
  
)

export default component.exports